module.exports = __webpack_public_path__ + "static/img/企业文化9.f0fb2c38.png";